import styled from "styled-components";

import { Button } from "@similarweb/ui-components";

export const AssignToTeamButton = styled(Button)`
    white-space: nowrap;
`;
